import { useTranslation } from "react-i18next";

import type {
  IAlertButtonsType,
  IInformationAlertVariantProps,
} from "@components/molecules/alert/types";
import { Button } from "@components/atoms/button";

export function InformationAlertButtons(
  props: IAlertButtonsType<IInformationAlertVariantProps>,
) {
  const { closeTitle, onBeforeClose, onClose } = props;
  const { t } = useTranslation("actions");

  return (
    <Button
      mode={"secondary"}
      onClick={() => {
        if (onBeforeClose) {
          onBeforeClose();
        }
        onClose();
      }}
    >
      {closeTitle || t("close")}
    </Button>
  );
}
